/**
 * 图片特效输入指纹参数
 *
 * 为图片特效渲染、缓存复用与提交校验提供不依赖 WASM 的稳定序列化结果。
 * 本模块属于图片特效纯运行时，不依赖插件实例或面板状态。
 */
import { cloneDeep } from 'lodash';
import type { IImageEffectProps, IImageLayerProps, ILayerProps } from '@/version-types';

/**
 * 生成仅包含特效输入的稳定序列化参数
 *
 * `screenshotUrl` 与 `effectPosition` 都是特效渲染产物，不参与缓存指纹，
 * 避免一次渲染回写派生数据后把同一份输入误判为已变化。
 *
 * @param layer - 图片图层数据
 * @returns 用于生成特效缓存指纹的序列化参数
 */
export const getEffectParams = (layer: ILayerProps) => {
    if (!layer) return '';
    const { width, height } = layer;
    const data = cloneDeep(layer.data) as IImageLayerProps;
    const effect = data.effect as IImageEffectProps;
    if (effect) {
        effect.screenshotUrl = '';
        delete effect.effectPosition;
    }
    return JSON.stringify({
        width,
        height,
        ...data,
    });
};
